<app-layer-config-collapsible-category description="Observations" storageKey="vzo-observations">
  <app-layer-control-item
    isDemoEnabled
    [description]="(providerInfo$ | async)?.provider1 || 'Provider1'"
    [isLayerVisibile]="isProvider1ObservationsVisible"
    [layerId]="layerIds.Provider1Observations.name"
    icon="video-record"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    isDemoEnabled
    [description]="(providerInfo$ | async)?.provider2 || 'Provider2'"
    [isLayerVisibile]="isProvider2ObservationsVisible"
    [layerId]="layerIds.Provider2Observations.name"
    icon="video-record"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
